export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'sum',
    label: 'Amount',
  },
  {
    name: 'name',
    label: 'Name',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'status',
    label: 'Status',
  },
];

export const columnsLabels = {};

export const schema = {};

export const defaultSorter = {};
